'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = utms;

var _immutable = require('immutable');

var _UtmDataActionTypes = require('../actionTypes/UtmDataActionTypes');

var _utmHelpers = require('../utils/utmHelpers.js');

var DEFAULT = (0, _immutable.Map)({
  filtered: new _immutable.Map(),
  howUtms: new _immutable.Map(),
  expOnly: new _immutable.Map()
});

function utms() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _UtmDataActionTypes.UTM_DATA_FETCHED:
      {
        var utmsFiltered = (0, _utmHelpers.parseUtmData)(payload);
        return state.merge((0, _immutable.fromJS)({
          filtered: utmsFiltered,
          howUtms: (0, _utmHelpers.mergeFromExp)(utmsFiltered),
          expOnly: (0, _utmHelpers.getOnlyExpParams)(utmsFiltered),
          utmFetched: true
        }));
      }
    default:
      {
        return state;
      }
  }
}
module.exports = exports['default'];